<template>
  <div>
    <div class="profile-title-wrap flex">
      <div>
        <a
          class="go-back-wrap"
          href="javascript:;"
          @click="switchTreeOrProfile"
        >
          <i class="el-icon-arrow-left"></i>
          <span>返回家谱</span>
        </a>
      </div>
      <div class="title-text">完善亲人资料</div>
      <div style="width: 35px"></div>
    </div>
    <div class="relative-profile-wrap">
      <el-form
        :model="userProfileForm"
        :rules="rules"
        ref="userProfileForm"
        label-width="100px"
        class="user-profile-form"
      >
        <el-form-item prop="thumbHeadImg" class="head-image-wrapper">
          <div class="head-image-container">
            <img
              class="user-profile-avatar"
              src="../../../assets/image/cl_user_avatar.png"
              v-real-img="initUserAvatar"
            />
            <p class="change-avatar-btn" @click="modifyAvatar">更换头像</p>
          </div>
          <!-- <p class="modify-avatar-wrap" v-if="!editForbit">
            <el-button class="handlian-btn" @click="modifyAvatar"
              >更换头像</el-button
            >
          </p> -->
          <el-input
            type="hidden"
            v-model="userProfileForm.thumbHeadImg"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="姓名"
          prop="name"
          class="profile-form-item name-item"
        >
          <div class="profile-item-content">
            <el-input
              v-model="userProfileForm.name"
              placeholder="输入姓名"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="性别"
          prop="sex"
          class="profile-form-item name-item"
        >
          <div class="profile-item-content">
            <span v-if="nodeInfo.sex == '1'" class="content-text">男</span>
            <span v-else class="content-text">女</span>
          </div>
        </el-form-item>
        <div class="relative-date-container flex">
          <el-form-item
            label="出生日期"
            prop="birthYear"
            class="profile-form-item"
          >
            <el-input
              v-model="userProfileForm.birthYear"
              @change="birthYearChange"
              placeholder="吉年"
            ></el-input>
            <span class="year-text" ref="birthYearText"></span>
          </el-form-item>
          <el-form-item prop="birthMonth">
            <el-select
              placeholder="吉月"
              v-model="userProfileForm.birthMonth"
              @change="birthMonthChange"
            >
              <el-option
                v-for="(item, index) in monthArr"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="birthDay">
            <el-select
              placeholder="吉日"
              v-model="userProfileForm.birthDay"
              @change="birthDayChange"
            >
              <el-option
                v-for="(item, index) in dayArr"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="birthTime">
            <el-select v-model="userProfileForm.birthTime" placeholder="吉时">
              <el-option
                v-for="(item, index) in timeArr"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="relative-date-container flex">
          <el-form-item
            label="离世日期"
            prop="deathYear"
            class="profile-form-item"
          >
            <el-input
              v-model="userProfileForm.deathYear"
              @change="deathYearChange"
              placeholder="吉年"
            ></el-input>
            <span class="year-text" ref="deathYearText"></span>
          </el-form-item>
          <el-form-item prop="deathMonth">
            <el-select
              placeholder="吉月"
              v-model="userProfileForm.deathMonth"
              @change="deathMonthChange"
            >
              <el-option
                v-for="(item, index) in monthArr"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="deathDay">
            <el-select
              placeholder="吉日"
              v-model="userProfileForm.deathDay"
              @change="deathDayChange"
            >
              <el-option
                v-for="(item, index) in dayArr"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="deathTime">
            <el-select v-model="userProfileForm.deathTime" placeholder="吉时">
              <el-option
                v-for="(item, index) in timeArr"
                :key="index"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="乳名" prop="petName" class="profile-form-item">
          <div class="profile-item-content">
            <el-input
              v-model="userProfileForm.petName"
              placeholder="输入乳名"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="出生地"
          prop="birthAddress"
          class="profile-form-item"
        >
          <div class="profile-item-content">
            <el-input
              v-model="userProfileForm.birthAddress"
              placeholder="输入出生地"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="常住地"
          prop="placeAddress"
          class="profile-form-item"
        >
          <div class="profile-item-content">
            <el-input
              v-model="userProfileForm.placeAddress"
              placeholder="输入常住地"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="个人简介"
          prop="introduction"
          class="profile-form-item"
        >
          <div class="profile-item-content">
            <el-input
              type="textarea"
              v-model="userProfileForm.introduction"
              resize="none"
              maxlength="200"
              show-word-limit
              :autosize="{ minRows: 2 }"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('userProfileForm')"
            class="handlian-btn"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="vue-cropper-wrap">
      <el-dialog
        title="更换头像"
        :before-close="handleClose"
        :visible.sync="imageCropperVisible"
        custom-class="handlian-cropper-container"
        width="645px"
      >
        <ImageCropper ref="imageCropper" @cropDone="cropDone" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { apiMap } from "../../../utils/apiMap";
import ImageCropper from "../image-cropper";
import qs from "qs";
export default {
  name: "death-node",
  props: {
    nodeInfo: Object,
  },
  components: {
    ImageCropper,
  },
  data() {
    var initMonth = [{ text: "吉月", value: "0" }];
    var initDay = [{ text: "吉日", value: "0" }];
    var initTime = [{ text: "吉时", value: "0" }];
    for (let index = 1; index < 13; index++) {
      const element = {
        text: `${index}月`,
        value: index < 10 ? `0${index}` : String(index),
      };
      initMonth.push(element);
    }
    for (let index = 1; index < 32; index++) {
      const element = {
        text: `${index}日`,
        value: index < 10 ? `0${index}` : String(index),
      };
      initDay.push(element);
    }
    for (let index = 1; index < 25; index++) {
      const element = {
        text: `${index}时`,
        value: index < 10 ? `0${index}` : String(index),
      };
      initTime.push(element);
    }
    var validateYear = (rule, value, callback) => {
      var numberRegExp = /^[0-9]{1,4}$/;
      var blankRegExp = /^\S*$/;
      if (value !== "") {
        if (!blankRegExp.test(value)) {
          callback(new Error("年份不允许有空格"));
        } else if (!numberRegExp.test(value)) {
          callback(new Error("年份为1~4位数字"));
        } else if (value.indexOf("0") == 0) {
          callback(new Error("年份首位不能是0"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      imageCropperVisible: false,
      userProfileForm: {
        name: "",
        sex: "",
        birthYear: "",
        birthMonth: "",
        birthDay: "",
        birthTime: "",
        deathYear: "",
        deathMonth: "",
        deathDay: "",
        deathTime: "",
        petName: "",
        birthAddress: "",
        placeAddress: "",
        introduction: "",
        headImgUrl: "",
        thumbHeadImg: "",
      },
      monthArr: initMonth,
      dayArr: initDay,
      timeArr: initTime,
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            min: 1,
            max: 40,
            message: "长度在 2 到 40 个字符",
            trigger: "blur",
          },
        ],
        birthYear: [{ validator: validateYear, trigger: "blur" }],
        deathYear: [{ validator: validateYear, trigger: "blur" }],
        petName: [
          { required: false, message: "请输入乳名", trigger: "blur" },
          {
            min: 1,
            max: 25,
            message: "长度在 1 到 50 个字符",
            trigger: "blur",
          },
        ],
        birthAddress: [
          { required: false, message: "请输入出生地", trigger: "blur" },
          {
            min: 1,
            max: 25,
            message: "长度在 1 到 150 个字符",
            trigger: "blur",
          },
        ],
        placeAddress: [
          { required: false, message: "请输入常住地", trigger: "blur" },
          {
            min: 1,
            max: 25,
            message: "长度在 1 到 150 个字符",
            trigger: "blur",
          },
        ],
        introduction: [
          { required: false, message: "请输入个人简介", trigger: "blur" },
          {
            min: 1,
            max: 200,
            message: "长度在 1 到 200 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    initUserAvatar() {
      if (this.userProfileForm.thumbHeadImg) {
        return this.userProfileForm.thumbHeadImg;
      } else {
        return "http://148.70.221.198/pc/image/cl_user_avatar.png";
      }
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var birthYear = +this.userProfileForm.birthYear;
          var deathYear = +this.userProfileForm.deathYear;
          var diffYear = deathYear - birthYear;
          var curYear = new Date().getFullYear();
          var trueYear = curYear - deathYear;
          if (birthYear > 0 && deathYear > 0 && diffYear < 0) {
            this.$alert("离世年份不能小于出生年份", {
              confirmButtonText: "确定",
              showClose: false,
            });
            return false;
          }
          if (trueYear < 0) {
            this.$alert("离世年份不能大于当前年份", {
              confirmButtonText: "确定",
              showClose: false,
            });
            return false;
          }
          var inputFullBirth = "0";
          var inputFullDeath = "0";
          if (birthYear > 0) {
            var inputBirthYear, inputBirthMonth, inputBirthDay, inputBirthTime;
            inputBirthMonth = this.userProfileForm.birthMonth;
            inputBirthYear =
              inputBirthMonth == "" ? birthYear : `${birthYear}.`;
            inputBirthDay =
              inputBirthMonth == "" ? "" : this.userProfileForm.birthDay;
            inputBirthTime =
              inputBirthDay == "" ? "" : this.userProfileForm.birthTime;
            if (inputBirthDay != "") {
              inputBirthMonth = `${inputBirthMonth}.`;
            }
            if (inputBirthTime != "") {
              inputBirthDay = `${inputBirthDay}.`;
            }
            inputFullBirth =
              inputBirthYear + inputBirthMonth + inputBirthDay + inputBirthTime;
          }
          if (deathYear > 0) {
            var inputDeadYear, inputDeadMonth, inputDeadDay, inputDeadTime;
            inputDeadMonth = this.userProfileForm.deathMonth;
            inputDeadYear = inputDeadMonth == "" ? deathYear : `${deathYear}.`;
            inputDeadDay =
              inputDeadMonth == "" ? "" : this.userProfileForm.deathDay;
            inputDeadTime =
              inputDeadDay == "" ? "" : this.userProfileForm.deathTime;
            if (inputDeadDay != "") {
              inputDeadMonth = `${inputDeadMonth}.`;
            }
            if (inputDeadTime != "") {
              inputDeadDay = `${inputDeadDay}.`;
            }
            inputFullDeath =
              inputDeadYear + inputDeadMonth + inputDeadDay + inputDeadTime;
          }
          let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
          var submitData = {
            action: this.nodeInfo.action,
            whoId: this.nodeInfo.userId,
            token: loginUser.token,
            userId: loginUser.userId,
            name: this.userProfileForm.name,
            birthAddress: this.userProfileForm.birthAddress,
            locationAddress: this.userProfileForm.placeAddress,
            usedName: this.userProfileForm.petName,
            description: this.userProfileForm.introduction,
            headImg: this.userProfileForm.headImgUrl,
            thumbHeadImg: this.userProfileForm.thumbHeadImg,
          };
          if (inputFullBirth != "0") {
            submitData.birthday = inputFullBirth;
          }
          if (inputFullBirth != "0") {
            submitData.deathDay = inputFullDeath;
          }
          // if (checkInfo.addType=="1") {//添加死亡节点
          //     submit.whoId = checkInfo.userId; //已选的 某人的 ID
          //     submit.userId = loginUser.userId; //当前登录的 ID
          //     submit.sex = checkInfo.sex;
          //     submit.relationName = checkInfo.relation;
          //     submit.reverseRelation = checkInfo.reverseRelation;
          //     modifyFamilyTree(submit);
          // }else if (checkInfo.addType=="2") {//添加临时节点资料
          //     submit.whoId = checkInfo.userId;  //临时节点的ID
          //     submit.userId = loginUser.userId; //当前登录的 ID
          //     modifyTempNode(submit);
          // }
          if (this.nodeInfo.action == "1") {
            //新增死亡节点
            submitData.sex = this.nodeInfo.sex;
            submitData.relationName = this.nodeInfo.relation;
            submitData.reverseRelation = this.nodeInfo.reverseRelation;
            this.addDeathNode(submitData);
          } else {
            //完善临时节点
            this.updateUserProfile(qs.stringify(submitData, { encode: false }));
          }
        } else {
          return false;
        }
      });
    },
    addDeathNode(params) {
      //addDeathNode
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["addDeathNode"]["method"],
          url: apiMap["addDeathNode"]["url"],
          data: qs.stringify(params, { encode: false }),
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            var submitData = {
              token: params.token,
              relationName: params.relationName, //比如 被添加人是已选择人的 '父亲'，此参数为'父亲'
              relationUserId: response.data.result.data, //已故亲人的Id
              userId: params.whoId, //已选择的人id
            };
            _this.agreeDeadRelation(submitData);
          } else {
            _this.$message({
              message: "保存失败，稍后再试",
              duration: 1500,
              offset: 230,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    agreeDeadRelation(params) {
      let _this = this;
      params = qs.stringify(params, { encode: false });
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["agreeRelation"]["method"],
          url: apiMap["agreeRelation"]["url"],
          data: params,
        })
        .then(function(response) {
          // if (response.data.result.statusCode == 1) {
          //   _this.$message({
          //     message: "保存成功",
          //     type: "success",
          //     duration: 1500,
          //     offset: 230,
          //   });
          //   _this.$bus.$emit("reload-father-tree", "1");
          //   _this.switchTreeOrProfile(2);
          // } else {
          //   _this.$message({
          //     message: "保存失败，稍后再试",
          //     duration: 1500,
          //     offset: 230,
          //   });
          // }
          switch (response.data.result.statusCode) {
            case 0: {
              _this.$alert(response.data.result.data, {
                confirmButtonText: "确定",
                showClose: false,
              });
              break;
            }

            case 1: {
              _this.$message({
                message: "保存成功",
                type: "success",
                duration: 1500,
                offset: 230,
              });
              _this.$bus.$emit("reload-father-tree", "1");
              _this.switchTreeOrProfile(2);
              break;
            }

            case 2:
              _this.startRelationInteraction(
                qs.parse(params),
                response.data.result
              );
              break;

            default: {
              _this.$alert(response.data.result.data, {
                confirmButtonText: "确定",
                showClose: false,
              });
              break;
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    startRelationInteraction(submit, respond) {
      if (!Array.isArray(respond.data)) {
        return;
      }
      if (respond.data.length > 0) {
        let optionArr = [];
        const h = this.$createElement;
        optionArr.push(h("option", { attrs: { value: "" } }, "—— 亲人 ——"));
        respond.data.forEach((item) => {
          optionArr.push(
            h(
              "option",
              {
                attrs: {
                  value: item.userId,
                },
              },
              `${item.name}${item.sex === 1 ? " (男)" : " (女)"}`
            )
          );
        });
        optionArr.push(h("option", { attrs: { value: "-1" } }, "其他"));
        this.$msgbox({
          title: "请选择血缘关系人",
          message: h("div", null, [
            h(
              "select",
              {
                attrs: {
                  id: "chooseRelativeMate",
                  class: "handlian-select",
                },
              },
              optionArr
            ),
          ]),
          showCancelButton: true,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            let selectedID = document.getElementById("chooseRelativeMate")
              .value;
            if (action === "confirm") {
              // console.log(selectedID);
              if (selectedID == "") {
                this.$message({
                  type: "warning",
                  message: "请选择一个亲人",
                });
                return;
              }
              Object.defineProperty(submit, respond.field, {
                value: selectedID,
                writable: true,
                enumerable: true,
                configurable: true,
              });
              // let submitData = submit+'&nodeUserId='+selectedID;
              this.agreeDeadRelation(submit);
              done();
            } else {
              // let submitData = submit+'&nodeUserId=-1';
              Object.defineProperty(submit, respond.field, {
                value: "-1",
                writable: true,
                enumerable: true,
                configurable: true,
              });
              this.agreeDeadRelation(submit);
              done();
            }
          },
        })
          .then(() => {})
          .catch(() => {});
      } else {
        // let submitData = submit+'&nodeUserId=-1';
        Object.defineProperty(submit, respond.field, {
          value: "-1",
          writable: true,
          enumerable: true,
          configurable: true,
        });
        this.agreeDeadRelation(submit);
      }
    },
    updateUserProfile(params) {
      let _this = this;
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["updateNode"]["method"],
          url: apiMap["updateNode"]["url"],
          data: params,
        })
        .then(function(response) {
          if (response.data.result.statusCode == 1) {
            _this.$message({
              message: "保存成功",
              type: "success",
              duration: 1500,
              offset: 230,
            });
            _this.$bus.$emit("reload-father-tree", "1");
            _this.switchTreeOrProfile(1);
          } else {
            _this.$message({
              message: "保存失败，稍后再试",
              duration: 1500,
              offset: 230,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    switchTreeOrProfile(x) {
      this.clearProfileForm();
      this.$bus.$emit("switch-tree-profile", {});
    },
    birthYearChange(year) {
      if (year === "" || year.trim().length === 0) {
        this.userProfileForm.birthMonth = "";
        this.userProfileForm.birthDay = "";
        this.userProfileForm.birthTime = "";
        this.$refs.birthYearText.innerText = "";
      } else {
        var numberRegExp = /^[0-9]{1,4}$/;
        var blankRegExp = /^\S*$/;
        if (
          blankRegExp.test(year) &&
          numberRegExp.test(year) &&
          year.indexOf("0") != 0
        ) {
          this.$refs.birthYearText.innerText = "年";
        } else {
          this.$refs.birthYearText.innerText = "";
        }
      }
    },
    birthMonthChange(month) {
      if (month == "0") {
        this.userProfileForm.birthDay = "";
        this.userProfileForm.birthTime = "";
      }
    },
    birthDayChange(day) {
      if (day == "0") {
        this.userProfileForm.birthTime = "";
      }
    },
    deathYearChange(year) {
      if (year === "" || year.trim().length === 0) {
        this.userProfileForm.deathMonth = "";
        this.userProfileForm.deathDay = "";
        this.userProfileForm.deathTime = "";
        this.$refs.deathYearText.innerText = "";
      } else {
        var numberRegExp = /^[0-9]{1,4}$/;
        var blankRegExp = /^\S*$/;
        if (
          blankRegExp.test(year) &&
          numberRegExp.test(year) &&
          year.indexOf("0") != 0
        ) {
          this.$refs.deathYearText.innerText = "年";
        } else {
          this.$refs.deathYearText.innerText = "";
        }
      }
    },
    deathMonthChange(month) {
      if (month == "0") {
        this.userProfileForm.deathDay = "";
        this.userProfileForm.deathTime = "";
      }
    },
    deathDayChange(day) {
      if (day == "0") {
        this.userProfileForm.deathTime = "";
      }
    },
    clearProfileForm() {
      this.userProfile = {};
      this.profileShade = true;
      this.userProfileForm.sex = null;
      this.userProfileForm.birthYear = "";
      this.$refs.birthYearText.innerText = "";
      this.userProfileForm.birthMonth = "";
      this.userProfileForm.birthDay = "";
      this.userProfileForm.birthTime = "";
      this.userProfileForm.thumbHeadImg = null;
      this.$refs.deathYearText.innerText = "";
      this.userProfileForm.deathYear = "";
      this.userProfileForm.deathMonth = "";
      this.userProfileForm.deathDay = "";
      this.userProfileForm.deathTime = "";
      this.$refs["userProfileForm"].resetFields();
    },
    modifyAvatar() {
      this.imageCropperVisible = true;
    },
    handleClose() {
      this.$refs.imageCropper.resetCropper();
      this.imageCropperVisible = false;
    },
    cropDone(status, url) {
      this.imageCropperVisible = false;
      //状态1为头像上传成功
      if (status == 1) {
        this.userProfileForm.headImgUrl = url;
        this.userProfileForm.thumbHeadImg = url;
      }
    },
  },
};
</script>
<style scoped>
.profile-title-wrap {
  position: relative;
  height: 40px;
  color: #ffffff;
  line-height: 40px;
  letter-spacing: 2px;
  z-index: 3;
  justify-content: space-between;
  background-color: #1a70db;
}

.go-back-wrap {
  margin-left: 15px;
  padding: 6px 0;
  color: #fff;
  font-size: 14px;
}

.title-text {
  font-size: 16px;
}

.content-text {
  color: #606266;
  font-size: 16px;
}

.relative-profile-wrap {
  position: relative;
  padding: 25px 0 40px;
  min-height: 60px;
  font-size: 16px;
  line-height: 30px;
  background-color: #fff;
}

.head-image-wrapper {
  position: absolute;
  top: 25px;
  right: 142px;
}

.change-avatar-btn {
  display: none;
  position: relative;
  top: -40px;
  line-height: 25px;
  text-align: center;
  cursor: pointer;
  opacity: 0.7;
  color: #fff;
  background-color: #000;
}

.head-image-container:hover .change-avatar-btn {
  display: block;
}

.user-profile-avatar {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

.modify-avatar-wrap {
  text-align: center;
}

.profile-form-item {
  position: relative;
  width: 700px;
  font-size: 16px;
}

.name-item {
  width: 546px;
}

.year-text {
  position: absolute;
  top: 0;
  left: 55px;
  font-size: 16px;
}

.year-text:empty {
  display: none;
}

.relative-date-container {
  width: 700px;
}

.virtual {
  display: none;
}
</style>
